import BranchAPIs from '@/API/branch-api'

const AddBranchMixin = {
  data() {
    return {
      createMethod: 'clone',
      clonedBranchId: null,
    }
  },
  mounted() {
    this.clonedBranchId = this.currentBranchId
  },
  computed: {
    multiBranchesModal: {
      get() { return this.$store.getters['branches/multiBranchesModal'] },
      set(val) { return this.$store.commit('branches/SET_MULTI_BRANCHES_MODAL', val) },
    },
    addBranchModal: {
      get() { return this.$store.getters['branches/addBranchModal'] },
      set(val) { return this.$store.commit('branches/SET_ADD_BRANCH_MODAL', val) },
    },
  },
  methods: {
    async addBranch() {
      return BranchAPIs.create(this.createMethod, this.clonedBranchId)
        .then(({ branch, message }) => {
          this.$notifySuccess(message)
          return this.$store.dispatch('branches/UPDATE_BRANCH', branch)
        })
        .then(branch => { this.$store.dispatch('branches/SET_BRANCH', branch.id) })
        .then(() => this.$router.push({ name: 'admin:branches-management' }).catch(() => {}))
    },
  },
}

export default AddBranchMixin
